import * as React from 'react';
import { useEffect, useMemo } from 'react';
import { Select } from 'antd';

import * as EnumData from 'constants/enum';
import { useMount } from 'react-use';

const { Option } = Select;

export interface IEnumSelectorProps {
  data: Object;
  // eslint-disable-next-line no-unused-vars
  valueTranslator?: (v: any) => {};
  value: string;
  defaultValue?: string;
  defaultSelected?: boolean;
  onClick?: () => void;
  // eslint-disable-next-line no-unused-vars
  onChange?: (v: any) => void;
  defaultLabel?: string;
  enumId?: string;
  existTotal?: boolean;
  totalText?: string;
  totalValue?: string;
  placeholder?: string;
  style?: object;
  allowNumStringKey?: boolean;
  loading?: boolean;
  disabled?;
  // 검색 가능한 셀렉트로 쓸 때 (기본값은 기존 동작 유지)
  showSearch?: boolean;
  optionFilterProp?: string;
}

const EnumSelector: React.FC<IEnumSelectorProps> = (props) => {
  const {
    data,
    enumId,
    value,
    valueTranslator,
    style,
    defaultValue,
    defaultLabel = '',
    existTotal = false,
    totalText = '전체',
    totalValue = 'ALL',
    onChange = () => {},
    defaultSelected = true,
    placeholder = undefined,
    allowNumStringKey = false,
    loading = false,
    disabled,
    showSearch = false,
    optionFilterProp = 'value'
  } = props;

  if (!data && !enumId) return <div />;
  const _data = useMemo(() => {
    if (data) return data;
    // eslint-disable-next-line import/namespace
    if (EnumData && EnumData[enumId]) return EnumData[enumId];
    return null;
  }, [data, enumId]);

  const _onChange = (args) => {
    if (args === 'undefined') {
      onChange(undefined);
    }
    onChange(args);
  };

  const _defaultValue = useMemo(() => {
    let v = defaultValue;
    if (v) {
      return v;
    }

    if (defaultSelected) {
      if (existTotal) {
        v = totalValue;
      } else {
        v = Object.keys(_data).length > 0 ? Object.keys(_data)[0] : undefined;
      }
    }
    return v;
  }, [defaultValue, _data]);

  useMount(() => {
    if (typeof _defaultValue !== 'undefined' && _defaultValue !== null) onChange(_defaultValue);
  });

  return (
    <Select
      // {...props}
      value={allowNumStringKey ? value && String(value) : value}
      onChange={_onChange}
      style={{ minWidth: 100, ...style }}
      defaultValue={_defaultValue ?? (defaultLabel && 'undefined') ?? undefined}
      placeholder={placeholder}
      loading={loading}
      disabled={loading || disabled}
      showSearch={showSearch}
      optionFilterProp={optionFilterProp}
    >
      {/* {defaultLabel && <Option value={'undefined'}>{defaultLabel}</Option>} */}
      {existTotal && <Option value={totalValue}>{totalText}</Option>}
      {_data &&
        Object.keys(_data).map((key) => {
          const v = _data[key];
          if (allowNumStringKey || Number.isNaN(parseFloat(key)) === true) {
            return (
              <Option key={key} value={key}>
                {valueTranslator ? valueTranslator(v) : v}
              </Option>
            );
          }
          return null;
        })}
    </Select>
  );
};

export default EnumSelector;
